export const constantRoutes: Array<any> = [
  // login
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login/index.vue'),
    meta: { permission: false, name: '登录', title: '登录', showHeader: false },
  },
  // home
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/home/index.vue'),
    meta: { permission: true, name: '首页', title: '首页', showHeader: false }
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () => import('@/pages/knowledge/index.vue'),
    meta: { permission: true, name: '知识库', title: '知识库', showHeader: false }
  },
  {
    path: '/selected',
    name: 'Selected',
    component: () => import('@/pages/selected/index.vue'),
    meta: { permission: true, name: '代码仔精选', title: '代码仔精选', showHeader: false }
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('@/pages/member/index.vue'),
    meta: { permission: true, name: '会员中心', title: '会员中心', showHeader: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/login/register/index.vue'),
    meta: { permission: false, name: '注册', title: '注册', showHeader: false }
  },
  {
    path: '/forgot',
    name: 'ForgotPassword',
    component: () => import('@/pages/login/forgot/index.vue'),
    meta: { permission: false, name: '忘记密码', title: '忘记密码', showHeader: false }
  },
  {
    path: '/forgot/reset',
    name: 'ResetPassword',
    component: () => import('@/pages/login/forgot/components/ForgotFormStep2.vue'),
    meta: { permission: false, name: '重置密码', title: '重置密码', showHeader: false }
  },

  // user
  {
    path: '/user',
    name: 'User',
    component: () => import('@/pages/user/index.vue'),
    meta: { permission: true, name: '用户中心', title: '用户中心', showHeader: false }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/pages/profile/index.vue'),
    meta: { permission: true, name: '个人中心', title: '个人中心', showHeader: false }
  },
  {
    path: '/profile-info',
    name: 'ProfileInfo',
    component: () => import('@/pages/profileInfo/index.vue'),
    meta: { permission: true, name: '孕妇档案', title: '孕妇档案', showHeader: false }
  },

  {
    path: '/help-center',
    name: 'HelpCenter',
    component: () => import('@/pages/HelpCenter/index.vue'),
    meta: { permission: true, name: '帮助中心', title: '帮助中心', showHeader: false }
  },

  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/pages/PrivacyPolicy/index.vue'),
    meta: { permission: true, name: '隐私政策', title: '隐私政策', showHeader: false }
  },
  {
    path: '/favorite',
    name: 'Favorite',
    component: () => import('@/pages/Favorite/index.vue'),
    meta: { permission: true, name: '收藏服务', title: '收藏服务', showHeader: false }
  },
  {
    path: '/prenatal-records',
    name: 'PrenatalRecords',
    component: () => import('@/pages/PrenatalRecords/index.vue'),
    meta: { permission: true, name: '产检记录', title: '产检记录', showHeader: false }
  },
  {
    path: '/child-info',
    name: 'ChildInfo',
    component: () => import('@/pages/childrenInfo/index.vue'),
    meta: { permission: true, name: '胎儿档案', title: '胎儿档案', showHeader: false }
  },

  // 错误页面
  {
    path: '/401',
    name: '401',
    component: () => import('@/pages/errorPages/401.vue'),
    meta: { permission: false, showHeader: false }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/errorPages/404.vue'),
    meta: { permission: false, showHeader: false }
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/pages/errorPages/500.vue'),
    meta: { permission: false, showHeader: false }
  },
  {
    path: '/web-view',
    name: 'WebView',
    component: () => import('@/pages/WebView/index.vue'),
    meta: { permission: false, name: '网页视图', title: '网页视图', showHeader: false }
  },

]